import { useEffect } from "react";

import WOW from "wowjs";

function BreadcrumbsSection(props) {
  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  return (
    <div class="breadcrumbs overlay">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="breadcrumbs-content">
              <h1 class="page-title">{props.title}</h1>
              <p>
              
Explore our diversity and inclusion solutions
Making Inclusive Workplaces with Diverse Talent Placements

              </p>
            </div>
            <ul class="breadcrumb-nav">
              <li>
                <a href="/home">Home</a>
              </li>
              <li>{props.title}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BreadcrumbsSection;
